import { render } from "./SyncLog.vue?vue&type=template&id=72df1c70&scoped=true"
import script from "./SyncLog.vue?vue&type=script&lang=js"
export * from "./SyncLog.vue?vue&type=script&lang=js"

import "./SyncLog.vue?vue&type=style&index=0&id=72df1c70&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72df1c70"]])

export default __exports__